export default __webpack_public_path__ + "static/media/Zone-4-Master-Plan-Type-C.7ddb3c78.png";